<template>
  <article
    class=" text-brand/66 items-center spacer-block tablet:mb-0 bg-light block-round tablet:bg-transparent"
    :class="{
      'tablet:flex flex-row-reverse': page?.meta?.image_position === 'left',
      'tablet:flex justify-between gap-12': page?.meta?.image,
      'tablet:-mt-12': page?.meta?.image,
      'tablet:mt-12': !page?.meta?.image,
    }">
    <div class="basis-1/2 shrink-0 mb-3 tablet:mb-0">
      <header class="mb-3 tablet:mb-6">
        <h2 class="article-title text-brand">{{ page.title }}</h2>
        <h3
          v-if="page?.meta?.subtitle"
          class="text-lg text-brand/66">
          {{ page.meta.subtitle }}
        </h3>
      </header>
      <ContentRenderer :value="page" class="with-free-text basis-2/3 text-brand/66 mb-4 tablet:mb-6" />
      <div v-if="ctaList.length > 0" class="flex flex-wrap gap-4 mt-8">
        <ButtonCta v-for="cta in ctaList" :key="cta.label" :cta="cta" />
      </div>
    </div>
    <picture
            v-if="imgUri"
            :class="`w-full relative block aspect-[${imgAspectRatio}] rounded-2xl overflow-hidden`"
    >
      <media-source
              :uri="imgUri"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
              format="webp"
              as="source"
      />
      <media-source
              :uri="imgUri"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              format="jpg"
              as="img"
              class="w-full h-full object-cover relative z-1"
      />
    </picture>
  </article>
</template>

<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";
import type {Cta} from "~/components/button/interface/cta.interface";
const { page } = defineProps<{
    page: PageCollectionItemBase
}>();

const imgUri = computed<string>(() => (page?.meta?.image as string || '').replace('/assets', ''));
const config = useRuntimeConfig().public;
const imgAspectRatio = computed<string>(() => {
  const aspect = page?.meta?.image_aspect_ratio as string || '9/12';
  const [w, h] = aspect.split('/').map(Number);
  return `${w}/${h}`;
});
const ctaList = computed<Cta[]>(() => page.meta?.cta as Cta[] || []);
</script>
